module.exports = __webpack_public_path__ + "static/media/no_data.cfea7e13.svg";